window.addEventListener("load", () => {
  const subChoice = document.querySelector(".subscription_choice_input");
  if (subChoice) {
    subChoice.click();
  }
  const ctaPrice = document.querySelector("span.cta-price");
  if (ctaPrice) {
    ctaPrice.style.display = "block";
  }
  const subWidget = document.querySelector(".subscription-widget");
  if (subWidget) {
    subWidget.style.display = "flex";
  }
});

const productElement = document.querySelector("single-product");

const getVariant = (variantId) => {
  if (typeof currentProduct === "undefined" || !currentProduct) return null;
  return currentProduct.variants.find((v) => v.id == variantId) || null;
};

const adjustGalleryImages = (variant) => {
  const gallery = document.querySelector(".product-image-section .main-swiper");
  if (!gallery || !variant || !variant.featured_image || !window.mainSwiper) return;
  const variantImage = variant.featured_image.src.split("?")[0].replace(/^https?:/, "");
  const imgToBeActive = Array.from(gallery.querySelectorAll("img")).find((img) =>
    img.src.replace("_1024x1024", "").includes(variantImage)
  );
  if (!imgToBeActive) return;
  const slideToBeActive = imgToBeActive.closest(".swiper-slide");
  let indx = 0;
  gallery.querySelectorAll(".swiper-slide").forEach((slide, index) => {
    if (slide == slideToBeActive) {
      indx = index;
    }
  });
  window.mainSwiper.slideTo(indx);
};

const WG = {
  cfg: null,
  wrapper: null,
  timers: [],
  jqBound: false,

  init() {
    this.wrapper = document.querySelector("[data-wg-tiers]");
    const json = document.querySelector("[data-wg-tiers-json]");
    if (!this.wrapper || !json) return;
    try {
      this.cfg = JSON.parse(json.textContent);
    } catch (e) {
      this.cfg = null;
      return;
    }
    this.bindEvents();
    this.bindJq();
    this.forceBase();
    const base = this.baseVariant();
    let tier = this.cfg.initialTier || 1;
    if (base && base.available) {
      tier = [5, 3, 1].find((t) => t <= tier && this.tierAvailable(base, t)) || 1;
    }
    this.setQty(tier);
    this.schedule();
  },

  money(cents) {
    return Shopify.formatMoney(Math.round(cents), theme.moneyFormat);
  },

  root() {
    return this.wrapper.closest(".product-page-info") || document;
  },

  qtyInput() {
    return (
      document.querySelector(".product-page-info .product-page-info__quantity .input-quantity input") ||
      this.root().querySelector('input[name="quantity"]')
    );
  },

  getQty() {
    const input = this.qtyInput();
    const q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  },

  setQty(q) {
    const input = this.qtyInput();
    if (!input) return;
    input.value = q;
    const $ = window.jQueryTheme || window.jQuery;
    if ($) {
      const $input = $(input);
      $input.trigger("custom.change");
      if (window.theme && theme.ProductQuantity && theme.ProductQuantity.dublicate) {
        try {
          theme.ProductQuantity.dublicate($input.closest(".js-product-quantity"));
        } catch (e) {}
      }
    }
  },

  currentVariant() {
    if (!productElement) return null;
    return getVariant(Number(productElement.getAttribute("data-product-variant-id")));
  },

  baseVariant() {
    const v = this.currentVariant();
    if (!v || !this.cfg) return v;
    if (this.cfg.base[v.id]) return v;
    const m = this.cfg.map[v.id];
    if (m) return getVariant(m[0]) || v;
    return v;
  },

  isMultipack(v) {
    return !!(v && this.cfg && this.cfg.map[v.id]);
  },

  forceBase() {
    if (!this.cfg || this.cfg.qtyIndex < 0) return;
    const v = this.currentVariant();
    if (!this.isMultipack(v)) return;
    const options = this.wrapper.closest("[data-js-product-options]") || document;
    const el = options.querySelector(
      '[data-quantity-container] [data-js-option-value][data-value="' + this.cfg.baseValue + '"]'
    );
    if (el) el.click();
  },

  tierForQty(q) {
    if (q >= 5) return 5;
    if (q >= 3) return 3;
    return 1;
  },

  pctForTier(t) {
    if (t === 5) return Number(this.cfg.p5) || 0;
    if (t === 3) return Number(this.cfg.p3) || 0;
    return 0;
  },

  applyDisc(total, pct) {
    return total - Math.floor((total * pct) / 100);
  },

  tierAvailable(v, t) {
    if (!v || !v.available) return false;
    const b = this.cfg.base[v.id];
    if (b && b.limit) return b.inv >= t;
    return true;
  },

  isSub() {
    const r = document.querySelector(".subscription-widget__sub input");
    return !!(r && r.checked);
  },

  subUnit(v) {
    if (!v || !v.selling_plan_allocations || !v.selling_plan_allocations.length) return null;
    const planInput = document.querySelector("#subscribe");
    const planId = planInput ? String(planInput.value) : "";
    const alloc =
      v.selling_plan_allocations.find((a) => String(a.selling_plan_id) === planId) ||
      v.selling_plan_allocations[0];
    return alloc ? alloc.price : null;
  },

  setText(sel, text) {
    document.querySelectorAll(sel).forEach((el) => {
      el.textContent = text;
    });
  },

  render() {
    if (!this.cfg) return;
    const v = this.baseVariant();
    if (!v) return;

    const q = this.getQty();
    const tier = this.tierForQty(q);
    const pct = this.pctForTier(tier);
    const subUnit = this.subUnit(v);
    const sub = this.isSub() && subUnit !== null;

    const regular = v.price * q;
    const compare = Math.max(v.compare_at_price || 0, v.price) * q;
    const oneTotal = this.applyDisc(regular, pct);
    const subTotal = subUnit !== null ? this.applyDisc(subUnit * q, pct) : null;
    const finalTotal = sub ? subTotal : oneTotal;
    const strike = sub ? regular : compare;
    const imgs = this.cfg.base[v.id] || {};

    this.wrapper.querySelectorAll("[data-wg-tier]").forEach((card) => {
      const t = Number(card.getAttribute("data-wg-tier"));
      const ok = this.tierAvailable(v, t);
      const active = t === tier;
      card.classList.toggle("is-unavailable", !ok);
      card.classList.toggle("active", active);
      const input = card.querySelector(".quantity-radio-input");
      if (input) input.checked = active;

      const unit = sub ? subUnit : v.price;
      const each = this.applyDisc(unit * t, this.pctForTier(t)) / t;
      const eachEl = card.querySelector("[data-wg-each]");
      if (eachEl) eachEl.textContent = this.money(each) + " each";

      const src = imgs["i" + t] || imgs.i1 || "";
      const img = card.querySelector("[data-wg-img]");
      if (img) {
        const box = img.closest(".package-image");
        if (src) {
          if (img.getAttribute("src") !== src) img.setAttribute("src", src);
          if (box) box.style.display = "";
        } else if (box) {
          box.style.display = "none";
        }
      }
    });

    const subsnp = document.querySelector(".subsnp");
    const subnpm = document.querySelector(".subnpm");
    if (subsnp) {
      if (sub) {
        subsnp.textContent = this.money(subTotal);
        if (subnpm) {
          subnpm.textContent = this.money(regular);
          subnpm.style.display = regular > subTotal ? "inline" : "none";
        }
      } else {
        subsnp.textContent = this.money(oneTotal);
        if (subnpm) {
          subnpm.textContent = compare > oneTotal ? this.money(compare) : "";
          subnpm.style.display = compare > oneTotal ? "inline" : "none";
        }
      }
    }

    const normp = document.querySelector(".normp");
    if (normp) {
      normp.textContent = this.money(oneTotal);
      const np = document.querySelector(".np");
      const off = document.querySelector(".discount-percentage");
      if (compare > oneTotal) {
        if (np) {
          np.textContent = this.money(compare);
          np.style.display = "inline";
        }
        if (off) {
          off.textContent = Math.floor(((compare - oneTotal) * 100) / compare) + "% Off";
          off.style.display = "inline";
        }
      } else {
        if (np) np.style.display = "none";
        if (off) off.style.display = "none";
      }
    }

    if (subTotal !== null) {
      this.setText(".subscription-widget__sub .subscription-widget__price--compare", this.money(regular));
      this.setText(".subscription-widget__sub .subscription-widget__price--sale", this.money(subTotal));
    }
    this.setText(".subscription-widget__one .subscription-widget__price--sale", this.money(oneTotal));

    const cta = document.querySelector(".cta-price.product-cta-button-price") || document.querySelector(".cta-price");
    if (cta) {
      let html = this.money(finalTotal);
      if (strike > finalTotal) {
        html +=
          ' <div class="compareatp" style="text-decoration: line-through; color: #888;">' +
          this.money(strike) +
          "</div>";
      }
      cta.innerHTML = html;
    }
  },

  schedule() {
    if (!this.cfg) return;
    this.timers.forEach((t) => clearTimeout(t));
    this.render();
    this.timers = [120, 650].map((ms) => setTimeout(() => this.render(), ms));
  },

  onVariantChange() {
    if (!this.cfg) return;
    const v = this.currentVariant();
    if (this.isMultipack(v)) {
      this.forceBase();
      return;
    }
    const base = this.baseVariant();
    const q = this.getQty();
    const tier = this.tierForQty(q);
    if (base && base.available && tier > 1 && !this.tierAvailable(base, tier)) {
      const fallback = [5, 3, 1].find((t) => t < tier && this.tierAvailable(base, t)) || 1;
      this.setQty(fallback);
    }
    this.schedule();
  },

  bindEvents() {
    document.addEventListener("click", (event) => {
      const card = event.target.closest("[data-wg-tier]");
      if (!card || !this.wrapper.contains(card)) return;
      event.preventDefault();
      if (card.classList.contains("is-unavailable")) return;
      this.setQty(Number(card.getAttribute("data-wg-tier")));
      this.schedule();
    });

    window.addEventListener("click", (event) => {
      if (
        event.target.closest(".js-product-quantity [data-control]") ||
        event.target.closest(".subscription-widget__one") ||
        event.target.closest(".subscription-widget__sub")
      ) {
        this.schedule();
      }
    });

    document.addEventListener("input", (event) => {
      if (event.target.matches(".js-product-quantity input")) this.schedule();
    });

    document.addEventListener("change", (event) => {
      if (
        event.target.matches(".js-product-quantity input") ||
        event.target.matches(".subscription_choice_input") ||
        event.target.matches(".subscription-widget__frequency")
      ) {
        this.schedule();
      }
    });

    document.addEventListener("focusout", (event) => {
      if (event.target.matches(".js-product-quantity input")) this.schedule();
    });
  },

  bindJq() {
    let tries = 0;
    const attempt = () => {
      const $ = window.jQueryTheme || window.jQuery;
      if ($ && !this.jqBound) {
        this.jqBound = true;
        $(document).on("custom.change", ".js-product-quantity input", () => this.schedule());
        return;
      }
      if (++tries < 40) setTimeout(attempt, 250);
    };
    attempt();
  },
};

const adjustVariant = (newVariantId) => {
  const newCurrentVariant = getVariant(newVariantId);
  document.querySelectorAll("[data-js-buy-now-button]").forEach((btn) => {
    if (newCurrentVariant && newCurrentVariant.available) {
      btn.removeAttribute("disabled");
    } else {
      btn.setAttribute("disabled", "disabled");
    }
  });
  adjustGalleryImages(newCurrentVariant);
  WG.onVariantChange();
};

if (productElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "data-product-variant-id") {
        adjustVariant(Number(productElement.getAttribute("data-product-variant-id")));
      }
    }
  });
  observer.observe(productElement, {
    attributes: true,
    attributeFilter: ["data-product-variant-id"],
  });
}

const wgStart = () => {
  WG.init();
  if (productElement) {
    adjustGalleryImages(getVariant(Number(productElement.getAttribute("data-product-variant-id"))));
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", wgStart);
} else {
  wgStart();
}

window.addEventListener("load", () => {
  if (!WG.cfg) return;
  WG.forceBase();
  WG.schedule();
  setTimeout(() => {
    WG.forceBase();
    WG.schedule();
  }, 1500);
});